<template>
    <div>
        <Counter />
        <ul class="nav nav-tabs nav-fill" role="tablist">
            <li role="presentation" class="text-uppercase hand nav-item">
                <a href="#news" aria-controls="news" class="nav-link active" role="tab" data-toggle="tab">
                    {{ $t('button.latest') }}
                </a>
            </li>
            <li role="presentation" class="text-uppercase hand nav-item">
                <a href="#best" aria-controls="best" role="tab" data-toggle="tab" class="nav-link">
                    {{ $t('button.best') }}
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="right-panel-body tab-pane show active" role="tabpanel" id="news"
                 v-if="latestNews && latestNews.data">
                <div class="container-fluid">
                    <side-panel-preview v-for="news in latestNews.data" :key="'latest' + news.slug" :news="news"/>

                    <hr/>
                    <router-link class="btn btn-block btn-link" to="/news-list/latest">
                        {{ $t('button.More') }}
                    </router-link>
                </div>
            </div>
            <div class="right-panel-body tab-pane" role="tabpanel" id="best"
                 v-if="mostViewedNews && mostViewedNews.data">
                <div class="container-fluid">
                    <side-panel-preview v-for="news in mostViewedNews.data" :key="'best' + news.slug" :news="news"/>

                    <hr/>
                    <router-link class="btn btn-block btn-link" to="/news-list/best">
                        {{ $t('button.More') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SidePanelPreview from './SidePanelPreview';
  import Counter from '../../components/counter/Counter';

  export default {
    name: 'HomeSidePanel',
    components: { SidePanelPreview, Counter },
    props: ['latestNews', 'mostViewedNews']
  };
</script>

<style scoped>

</style>
